// constants
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";
// log
import { fetchData } from "../data/dataActions";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { initializeApp } from "firebase/app";
import { doc, setDoc, getDoc, getFirestore } from 'firebase/firestore';
import { collection, getDocs } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyA2dmS-_0K6TXdiI4YuaTGOYbr9bnsTKDU",
  authDomain: "splitfactory-72a37.firebaseapp.com",
  projectId: "splitfactory-72a37",
  storageBucket: "splitfactory-72a37.appspot.com",
  messagingSenderId: "1053257289252",
  appId: "1:1053257289252:web:61fdbfd888a6caf0c492b1"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const connectRequest = () => {
  return {
    type: "CONNECTION_REQUEST",
  };
};

const connectSuccess = (payload) => {
  return {
    type: "CONNECTION_SUCCESS",
    payload: payload,
  };
};

const connectFailed = (payload) => {
  return {
    type: "CONNECTION_FAILED",
    payload: payload,
  };
};

const updateAccountRequest = (payload) => {
  return {
    type: "UPDATE_ACCOUNT",
    payload: payload,
  };
};
const fetchDataSuccess2 = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS2",
    payload: payload,
  };
};
const fetchDataSuccess3 = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS3",
    payload: payload,
  };
};
const fetchDataSuccess4 = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS4",
    payload: payload,
  };
};
const fetchDataSuccess5 = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS5",
    payload: payload,
  };
};
const fetchDataSuccess6 = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS6",
    payload: payload,
  };
};

export const connect = () => {
  return async (dispatch) => {
    dispatch(connectRequest());
    const abiResponse = await fetch("/config/abi.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const abi = await abiResponse.json();
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const CONFIG = await configResponse.json();
    const { ethereum } = window;
    const metamaskIsInstalled = ethereum && ethereum.isMetaMask;
    if (metamaskIsInstalled) {
      Web3EthContract.setProvider(ethereum);
      let web3 = new Web3(ethereum);
      try {
        const accounts = await ethereum.request({
          method: "eth_requestAccounts",
        });
        const networkId = await ethereum.request({
          method: "net_version",
        });
        if (networkId == CONFIG.NETWORK.ID) {
          const SmartContractObj = new Web3EthContract(
            abi,
            CONFIG.CONTRACT_ADDRESS
          );
          
          dispatch(
            connectSuccess({
              account: accounts[0],
              smartContract: SmartContractObj,
              web3: web3,
            })
          );
          const querySnapshot = await getDocs(collection(db, accounts[0]));
          const addresses = [];
          querySnapshot.forEach((doc) => {
            //console.log(doc.id, " => ", doc.data());
            addresses.push(doc.id)
          });
          dispatch(
            fetchDataSuccess5({
              //account,
              //cost,
              addresses,
              //hasStakes,
              //SVIBESMinted
            })
          );
          // Add listeners start
          ethereum.on("accountsChanged", (accounts) => {
            dispatch(updateAccount(accounts[0]));
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });
          // Add listeners end
        } else {
          dispatch(connectFailed(`Change network to ${CONFIG.NETWORK.NAME}.`));
        }
      } catch (err) {
        dispatch(connectFailed("Something went wrong."));
      }
    } else {
      dispatch(connectFailed("Install Metamask."));
    }
  };
};

export const deploy = (formFields) => {
  let web3 = new Web3(ethereum);
  
  return async (dispatch) => {
    const accounts = await ethereum.request({
      method: "eth_requestAccounts",
    });
    const abi = [
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "payees",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "shares_",
            "type": "uint256[]"
          }
        ],
        "stateMutability": "payable",
        "type": "constructor"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "PaymentReceived",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "PaymentReleased",
        "type": "event"
      },
      {
        "inputs": [],
        "name": "getPayees",
        "outputs": [
          {
            "internalType": "address[]",
            "name": "",
            "type": "address[]"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "released",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "shares",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "totalReleased",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "stateMutability": "payable",
        "type": "receive"
      }
    ]
   
    const deploy_contract = new Web3EthContract(
      abi
    );
    
    let bytecode = "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"
    
    var addresses = [];
    var shares = [];
    for (let i = 0; i < formFields.length; i++) {
      addresses.push(formFields[i].address.toLowerCase());
      shares.push(formFields[i].share);
    }

      web3.eth.getGasPrice().then((result) => {
        let payload = {
          data: bytecode,
          arguments: [addresses, shares]
        }
        //console.log(web3.utils.fromWei(result, 'ether'))
        var parameter = {
          from: accounts[0],
          gasPrice: result,
          //maxFeePerGas: 2500000000,
          //maxPriorityFeePerGas: 2500000000,
          gasLimit: 650000
        }
        deploy_contract.deploy(payload).send(parameter, (err, transactionHash) => {
          console.log('Transaction Hash :', transactionHash);
        }).once("error", (err) => {
          console.log(err);
          toast.error('Sorry, something went wrong please try again later.', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark"
          });
        }).on('confirmation', () => { }).then((newContractInstance) => {
          toast.success('Successfully deployed your contract! 👍', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark"
          });
          console.log('Deployed Contract Address : ', newContractInstance.options.address.toLowerCase());
          setDoc(doc(db, "splits", "" + newContractInstance.options.address.toLowerCase()), {
            deployer: accounts[0].toLowerCase(),
            time: new Date().toLocaleString(),
            payees: formFields,
          });
          for (let i = 0; i < formFields.length; i++) {
            setDoc(doc(db, formFields[i].address.toLowerCase(), "" + newContractInstance.options.address.toLowerCase()), {
              time: new Date().toLocaleString()
            });
          }
          setDoc(doc(db, accounts[0].toLowerCase(), "" + newContractInstance.options.address.toLowerCase()), {
            time: new Date().toLocaleString()
          });
          var deployedContract = "" + newContractInstance.options.address.toLowerCase();
          dispatch(
            fetchDataSuccess6({
              //account,
              //cost,
              deployedContract,
              //hasStakes,
              //SVIBESMinted
            })
          );
        })  
      })      
      
      
    
  };
};

export const getInfo = (deployedAddress) => {
  let web3 = new Web3(ethereum);
  return async (dispatch) => {
    const accounts = await ethereum.request({
      method: "eth_requestAccounts",
    });
    const querySnapshot = await getDocs(collection(db, accounts[0]));
    const addresses = [];
    querySnapshot.forEach((doc) => {
      //console.log(doc.id, " => ", doc.data());
      addresses.push(doc.id)
    });
    dispatch(
      fetchDataSuccess5({
        //account,
        //cost,
        addresses,
        //hasStakes,
        //SVIBESMinted
      })
    );
    const abi = [
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "payees",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "shares_",
            "type": "uint256[]"
          }
        ],
        "stateMutability": "payable",
        "type": "constructor"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "PaymentReceived",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "PaymentReleased",
        "type": "event"
      },
      {
        "inputs": [],
        "name": "getPayees",
        "outputs": [
          {
            "internalType": "address[]",
            "name": "",
            "type": "address[]"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "released",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "shares",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "totalReleased",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "stateMutability": "payable",
        "type": "receive"
      }
    ]
    const deploy_contract = new web3.eth.Contract(abi, deployedAddress);
    deploy_contract.methods.totalReleased().call()
      .then(function (result) {
        var totalReleased = result
        dispatch(
          fetchDataSuccess2({
            //account,
            //cost,
            totalReleased
            //hasStakes,
            //SVIBESMinted
          })
        );
});
    deploy_contract.methods.getPayees().call()
      .then(function (result) {
        var payees = result
        dispatch(
          fetchDataSuccess3({
            //account,
            //cost,
            payees,
            //hasStakes,
            //SVIBESMinted
          })
        );
      });
  };
};

export const updateAddressesFromFirebase = () => {
  let web3 = new Web3(ethereum);
  return async (dispatch) => {
    const accounts = await ethereum.request({
      method: "eth_requestAccounts",
    });
    const querySnapshot = await getDocs(collection(db, accounts[0]));
    const addresses = [];
    querySnapshot.forEach((doc) => {
      //console.log(doc.id, " => ", doc.data());
      addresses.push(doc.id)
    });
    dispatch(
      fetchDataSuccess5({
        //account,
        //cost,
        addresses,
        //hasStakes,
        //SVIBESMinted
      })
    );
    
  };
};
export const getShare = (deployedAddress,payee) => {
  let web3 = new Web3(ethereum);

  return async (dispatch) => {

    const abi = [
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "payees",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "shares_",
            "type": "uint256[]"
          }
        ],
        "stateMutability": "payable",
        "type": "constructor"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "PaymentReceived",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "PaymentReleased",
        "type": "event"
      },
      {
        "inputs": [],
        "name": "getPayees",
        "outputs": [
          {
            "internalType": "address[]",
            "name": "",
            "type": "address[]"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "released",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "shares",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "totalReleased",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "stateMutability": "payable",
        "type": "receive"
      }
    ]
    var totalReleased
    var released
    var share
    const deploy_contract = new web3.eth.Contract(abi, deployedAddress);
    deploy_contract.methods.totalReleased().call()
      .then(function (result) {
        totalReleased = result;
      });
    var released;
    deploy_contract.methods.released(payee).call()
      .then(function (result) {
        released = result
        dispatch(
          fetchDataSuccess4({
            //account,
            //cost,
            totalReleased,
            share,
            released
            //SVIBESMinted
          })
        );
      });
    deploy_contract.methods.shares(payee).call()
      .then(function (result) {
        share = result
        dispatch(
          fetchDataSuccess4({
            //account,
            //cost,
            totalReleased,
            share,
            released
            //SVIBESMinted
          })
        );
      });

  };
};

export const updateAccount = (account) => {
  return async (dispatch) => {
    dispatch(updateAccountRequest({ account: account }));
    dispatch(fetchData(account));
  };
};
